<template>
  <div>
    <h1 class="admin-title">
      <el-button @click="goToPosts" style="margin-right:10px;">Back</el-button>Blog Editor
    </h1>
    <div class="admin-container">
      <el-form label-position="top" label-width="100px" class="blog-form" :model="post">
        <div class="form-save">
          <el-form-item label="Status">
            <el-select v-model="post.status" placeholder="Status">
              <el-option key="draft" label="Draft" value="DRAFT"></el-option>
              <el-option key="status" label="Published" value="PUBLISHED"></el-option>
              <el-option key="scheduled" label="Publish Scheduled" value="SCHEDULED"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-row>
              <el-col :span="12" style="text-align:left">Featured Post?</el-col>
              <el-col :span="12" style="text-align:right"><el-switch v-model="post.featured"/></el-col>
            </el-row>
          </el-form-item>
          <el-form-item v-if="post.status==='SCHEDULED'">
            <el-row>
              <el-col :span="24" style="text-align:left">Publish Date</el-col>
              <el-col :span="24" style="text-align:right">
                <el-date-picker
                  v-model="post.publishedDate"
                  type="date"
                  style="width:100%"
                  placeholder="Pick a day"/>
              </el-col>
            </el-row>
          </el-form-item>
          <el-button @click="onSave" :loading="savingData" type="primary">Save</el-button>
          <el-button @click="previewPost" v-show="post.id" type="default">Preview</el-button>
        </div>
        <el-form-item label="Main Image">
          <div class="main-blog-image-editor">
            <el-button v-if="post.image===null" @click="mainImageUpload" type="default">Upload Image</el-button>
            <el-button v-if="post.image!==null" @click="removeMainImage" type="danger">Remove Image</el-button>
            <img v-if="post.image!==null" v-bind:src="post.image">
          </div>
        </el-form-item>
        <el-form-item label="Title">
          <el-input placeholder="Give this blog post a title" v-model="post.name"></el-input>
        </el-form-item>
        <el-form-item label="Preview text">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6}"
            placeholder="Short intro to article"
            max-lenght="150"
            v-model="post.previewText"
          ></el-input>
        </el-form-item>
        <el-form-item label="Post Content">
          <quill-editor
            v-model="post.content"
            ref="quillEditor"
            :options="editorOption"
            @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)"
            @ready="onEditorReady($event)"
          />
        </el-form-item>
        <el-form-item label="Wista Video Week 1">
          <el-input placeholder="Video ID from Wistia for Embed" v-model="post.wistia"></el-input>
          <div v-if="post.wistia">
            <div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;">
              <div
                class="wistia_responsive_wrapper"
                style="height:100%;left:0;position:absolute;top:0;width:100%;"
              >
                <div
                  v-bind:class="'wistia_async_'+post.wistia"
                  class="wistia_embed seo=false videoFoam=true"
                  style="height:100%;position:relative;width:100%"
                >
                  <div
                    class="wistia_swatch"
                    style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"
                  >
                    <img
                      v-bind:src="wistiaEmbed"
                      style="filter:blur(5px);height:100%;object-fit:contain;width:100%;"
                      alt
                      onload="this.parentNode.style.opacity=1;"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="Wista Video Week 2">
          <el-input placeholder="Video ID from Wistia for Embed" v-model="post.wistia2"></el-input>
          <div v-if="post.wistia2">
            <div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;">
              <div
                class="wistia_responsive_wrapper"
                style="height:100%;left:0;position:absolute;top:0;width:100%;"
              >
                <div
                  v-bind:class="'wistia_async_'+post.wistia2"
                  class="wistia_embed seo=false videoFoam=true"
                  style="height:100%;position:relative;width:100%"
                >
                  <div
                    class="wistia_swatch"
                    style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"
                  >
                    <img
                      v-bind:src="wistiaEmbed2"
                      style="filter:blur(5px);height:100%;object-fit:contain;width:100%;"
                      alt
                      onload="this.parentNode.style.opacity=1;"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="Wista Video Week 3">
          <el-input placeholder="Video ID from Wistia for Embed" v-model="post.wistia3"></el-input>
          <div v-if="post.wistia3">
            <div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;">
              <div
                class="wistia_responsive_wrapper"
                style="height:100%;left:0;position:absolute;top:0;width:100%;"
              >
                <div
                  v-bind:class="'wistia_async_'+post.wistia3"
                  class="wistia_embed seo=false videoFoam=true"
                  style="height:100%;position:relative;width:100%"
                >
                  <div
                    class="wistia_swatch"
                    style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"
                  >
                    <img
                      v-bind:src="wistiaEmbed3"
                      style="filter:blur(5px);height:100%;object-fit:contain;width:100%;"
                      alt
                      onload="this.parentNode.style.opacity=1;"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="Wista Video Week 4">
          <el-input placeholder="Video ID from Wistia for Embed" v-model="post.wistia4"></el-input>
          <div v-if="post.wistia4">
            <div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;">
              <div
                class="wistia_responsive_wrapper"
                style="height:100%;left:0;position:absolute;top:0;width:100%;"
              >
                <div
                  v-bind:class="'wistia_async_'+post.wistia4"
                  class="wistia_embed seo=false videoFoam=true"
                  style="height:100%;position:relative;width:100%"
                >
                  <div
                    class="wistia_swatch"
                    style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"
                  >
                    <img
                      v-bind:src="wistiaEmbed4"
                      style="filter:blur(5px);height:100%;object-fit:contain;width:100%;"
                      alt
                      onload="this.parentNode.style.opacity=1;"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="Wista Video Week 5">
          <el-input placeholder="Video ID from Wistia for Embed" v-model="post.wistia5"></el-input>
          <div v-if="post.wistia5">
            <div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;">
              <div
                class="wistia_responsive_wrapper"
                style="height:100%;left:0;position:absolute;top:0;width:100%;"
              >
                <div
                  v-bind:class="'wistia_async_'+post.wistia5"
                  class="wistia_embed seo=false videoFoam=true"
                  style="height:100%;position:relative;width:100%"
                >
                  <div
                    class="wistia_swatch"
                    style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"
                  >
                    <img
                      v-bind:src="wistiaEmbed5"
                      style="filter:blur(5px);height:100%;object-fit:contain;width:100%;"
                      alt
                      onload="this.parentNode.style.opacity=1;"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="Wista Video Week 6">
          <el-input placeholder="Video ID from Wistia for Embed" v-model="post.wistia6"></el-input>
          <div v-if="post.wistia6">
            <div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;">
              <div
                class="wistia_responsive_wrapper"
                style="height:100%;left:0;position:absolute;top:0;width:100%;"
              >
                <div
                  v-bind:class="'wistia_async_'+post.wistia6"
                  class="wistia_embed seo=false videoFoam=true"
                  style="height:100%;position:relative;width:100%"
                >
                  <div
                    class="wistia_swatch"
                    style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"
                  >
                    <img
                      v-bind:src="wistiaEmbed6"
                      style="filter:blur(5px);height:100%;object-fit:contain;width:100%;"
                      alt
                      onload="this.parentNode.style.opacity=1;"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="Wista Video Week 7">
          <el-input placeholder="Video ID from Wistia for Embed" v-model="post.wistia7"></el-input>
          <div v-if="post.wistia7">
            <div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;">
              <div
                class="wistia_responsive_wrapper"
                style="height:100%;left:0;position:absolute;top:0;width:100%;"
              >
                <div
                  v-bind:class="'wistia_async_'+post.wistia7"
                  class="wistia_embed seo=false videoFoam=true"
                  style="height:100%;position:relative;width:100%"
                >
                  <div
                    class="wistia_swatch"
                    style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"
                  >
                    <img
                      v-bind:src="wistiaEmbed8"
                      style="filter:blur(5px);height:100%;object-fit:contain;width:100%;"
                      alt
                      onload="this.parentNode.style.opacity=1;"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="Wista Video Week 8">
          <el-input placeholder="Video ID from Wistia for Embed" v-model="post.wistia8"></el-input>
          <div v-if="post.wistia8">
            <div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;">
              <div
                class="wistia_responsive_wrapper"
                style="height:100%;left:0;position:absolute;top:0;width:100%;"
              >
                <div
                  v-bind:class="'wistia_async_'+post.wistia8"
                  class="wistia_embed seo=false videoFoam=true"
                  style="height:100%;position:relative;width:100%"
                >
                  <div
                    class="wistia_swatch"
                    style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"
                  >
                    <img
                      v-bind:src="wistiaEmbed9"
                      style="filter:blur(5px);height:100%;object-fit:contain;width:100%;"
                      alt
                      onload="this.parentNode.style.opacity=1;"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="Wista Video Week 9">
          <el-input placeholder="Video ID from Wistia for Embed" v-model="post.wistia9"></el-input>
          <div v-if="post.wistia9">
            <div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;">
              <div
                class="wistia_responsive_wrapper"
                style="height:100%;left:0;position:absolute;top:0;width:100%;"
              >
                <div
                  v-bind:class="'wistia_async_'+post.wistia9"
                  class="wistia_embed seo=false videoFoam=true"
                  style="height:100%;position:relative;width:100%"
                >
                  <div
                    class="wistia_swatch"
                    style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"
                  >
                    <img
                      v-bind:src="wistiaEmbed10"
                      style="filter:blur(5px);height:100%;object-fit:contain;width:100%;"
                      alt
                      onload="this.parentNode.style.opacity=1;"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="Wista Video Week 10">
          <el-input placeholder="Video ID from Wistia for Embed" v-model="post.wistia10"></el-input>
          <div v-if="post.wistia10">
            <div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;">
              <div
                class="wistia_responsive_wrapper"
                style="height:100%;left:0;position:absolute;top:0;width:100%;"
              >
                <div
                  v-bind:class="'wistia_async_'+post.wistia10"
                  class="wistia_embed seo=false videoFoam=true"
                  style="height:100%;position:relative;width:100%"
                >
                  <div
                    class="wistia_swatch"
                    style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"
                  >
                    <img
                      v-bind:src="wistiaEmbed10"
                      style="filter:blur(5px);height:100%;object-fit:contain;width:100%;"
                      alt
                      onload="this.parentNode.style.opacity=1;"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import Quill from "quill";

export default {
  name: "article",
  data() {
    return {
      content: null,
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            [{ align: [] }],
            ["clean"],
            ["link", "image", "video"]
          ]
        }
      },
      post: {
        id: null,
        name: null,
        status: "DRAFT",
        publishedDate: null,
        featured: false,
        content: "",
        image: null,
        wistia: null,
        wistia1: null,
        wistia2: null,
        wistia3: null,
        wistia4: null,
        wistia5: null,
        wistia6: null,
        wistia7: null,
        wistia8: null,
        wistia9: null,
        wistia10: null
      },
      wistiaJSONP: null,
      wistiaJSONP2: null,
      wistiaJSONP3: null,
      wistiaJSONP4: null,
      wistiaJSONP5: null,
      wistiaJSONP6: null,
      wistiaJSONP7: null,
      wistiaJSONP8: null,
      wistiaJSONP9: null,
      wistiaJSONP10: null,
      wistiaEmbed: null,
      wistiaEmbed2: null,
      wistiaEmbed3: null,
      wistiaEmbed4: null,
      wistiaEmbed5: null,
      wistiaEmbed6: null,
      wistiaEmbed7: null,
      wistiaEmbed8: null,
      wistiaEmbed9: null,
      wistiaEmbed10: null,
      wistiaScript: null,
      wistiaScript2: null,
      wistiaScript3: null,
      wistiaScript4: null,
      wistiaScript5: null,
      wistiaScript6: null,
      wistiaScript7: null,
      wistiaScript8: null,
      wistiaScript9: null,
      wistiaScript10: null,
      savingData: false
    };
  },
  watch: {
    "post.wistia": function() {
      if (this.wistiaScript)
        this.wistiaScript.parentNode.removeChild(this.wistiaScript);
      if (!this.post.wistia) {
        //Empty call values
        this.wistiaJSONP = null;
        this.wistiaEmbed = null;
      } else {
        this.wistiaJSONP =
          "https://fast.wistia.com/embed/medias/" + this.post.wistia + ".jsonp";
        this.wistiaScript = document.createElement("script");
        this.wistiaScript.setAttribute("src", this.wistiaJSONP);
        document.head.appendChild(this.wistiaScript);
        this.wistiaEmbed =
          "https://fast.wistia.com/embed/medias/" +
          this.post.wistia +
          "/swatch";
      }
    },
    "post.wistia2": function() {
      console.log("2 Changed");
      if (this.wistiaScript2)
        this.wistiaScript2.parentNode.removeChild(this.wistiaScript2);
      if (!this.post.wistia2) {
        //Empty call values
        this.wistiaJSONP2 = null;
        this.wistiaEmbed2 = null;
      } else {
        this.wistiaJSONP2 =
          "https://fast.wistia.com/embed/medias/" +
          this.post.wistia2 +
          ".jsonp";
        this.wistiaScript2 = document.createElement("script");
        this.wistiaScript2.setAttribute("src", this.wistiaJSONP2);
        document.head.appendChild(this.wistiaScript2);
        this.wistiaEmbed2 =
          "https://fast.wistia.com/embed/medias/" +
          this.post.wistia2 +
          "/swatch";
      }
    },
    "post.wistia3": function() {
      if (this.wistiaScript3)
        this.wistiaScript3.parentNode.removeChild(this.wistiaScript3);
      if (!this.post.wistia3) {
        //Empty call values
        this.wistiaJSONP3 = null;
        this.wistiaEmbed3 = null;
      } else {
        this.wistiaJSONP3 =
          "https://fast.wistia.com/embed/medias/" +
          this.post.wistia3 +
          ".jsonp";
        this.wistiaScript3 = document.createElement("script");
        this.wistiaScript3.setAttribute("src", this.wistiaJSONP3);
        document.head.appendChild(this.wistiaScript3);
        this.wistiaEmbed3 =
          "https://fast.wistia.com/embed/medias/" +
          this.post.wistia3 +
          "/swatch";
      }
    },
    "post.wistia": function() {
      if (this.wistiaScript4)
        this.wistiaScript4.parentNode.removeChild(this.wistiaScript4);
      if (!this.post.wistia4) {
        //Empty call values
        this.wistiaJSONP4 = null;
        this.wistiaEmbed4 = null;
      } else {
        this.wistiaJSONP4 =
          "https://fast.wistia.com/embed/medias/" + this.post.wistia + ".jsonp";
        this.wistiaScript4 = document.createElement("script");
        this.wistiaScript4.setAttribute("src", this.wistiaJSONP4);
        document.head.appendChild(this.wistiaScript4);
        this.wistiaEmbed4 =
          "https://fast.wistia.com/embed/medias/" +
          this.post.wistia4 +
          "/swatch";
      }
    },
    "post.wistia5": function() {
      if (this.wistiaScript5)
        this.wistiaScript5.parentNode.removeChild(this.wistiaScript5);
      if (!this.post.wistia5) {
        //Empty call values
        this.wistiaJSONP5 = null;
        this.wistiaEmbed5 = null;
      } else {
        this.wistiaJSONP5 =
          "https://fast.wistia.com/embed/medias/" +
          this.post.wistia5 +
          ".jsonp";
        this.wistiaScript5 = document.createElement("script");
        this.wistiaScript5.setAttribute("src", this.wistiaJSONP5);
        document.head.appendChild(this.wistiaScript5);
        this.wistiaEmbed5 =
          "https://fast.wistia.com/embed/medias/" +
          this.post.wistia5 +
          "/swatch";
      }
    },
    "post.wistia6": function() {
      if (this.wistiaScript6)
        this.wistiaScript6.parentNode.removeChild(this.wistiaScript6);
      if (!this.post.wistia6) {
        //Empty call values
        this.wistiaJSONP6 = null;
        this.wistiaEmbed6 = null;
      } else {
        this.wistiaJSONP6 =
          "https://fast.wistia.com/embed/medias/" +
          this.post.wistia6 +
          ".jsonp";
        this.wistiaScript6 = document.createElement("script");
        this.wistiaScript6.setAttribute("src", this.wistiaJSONP6);
        document.head.appendChild(this.wistiaScript6);
        this.wistiaEmbed6 =
          "https://fast.wistia.com/embed/medias/" +
          this.post.wistia6 +
          "/swatch";
      }
    },
    "post.wistia7": function() {
      if (this.wistiaScript7)
        this.wistiaScript7.parentNode.removeChild(this.wistiaScript7);
      if (!this.post.wistia7) {
        //Empty call values
        this.wistiaJSONP7 = null;
        this.wistiaEmbed7 = null;
      } else {
        this.wistiaJSONP7 =
          "https://fast.wistia.com/embed/medias/" +
          this.post.wistia7 +
          ".jsonp";
        this.wistiaScript7 = document.createElement("script");
        this.wistiaScript7.setAttribute("src", this.wistiaJSONP7);
        document.head.appendChild(this.wistiaScript7);
        this.wistiaEmbed7 =
          "https://fast.wistia.com/embed/medias/" +
          this.post.wistia7 +
          "/swatch";
      }
    },
    "post.wistia8": function() {
      if (this.wistiaScript)
        this.wistiaScript8.parentNode.removeChild(this.wistiaScript8);
      if (!this.post.wistia8) {
        //Empty call values
        this.wistiaJSONP8 = null;
        this.wistiaEmbed8 = null;
      } else {
        this.wistiaJSONP8 =
          "https://fast.wistia.com/embed/medias/" +
          this.post.wistia8 +
          ".jsonp";
        this.wistiaScript8 = document.createElement("script");
        this.wistiaScript8.setAttribute("src", this.wistiaJSONP8);
        document.head.appendChild(this.wistiaScript8);
        this.wistiaEmbed8 =
          "https://fast.wistia.com/embed/medias/" +
          this.post.wistia8 +
          "/swatch";
      }
    },
    "post.wistia9": function() {
      if (this.wistiaScript9)
        this.wistiaScript9.parentNode.removeChild(this.wistiaScript9);
      if (!this.post.wistia9) {
        //Empty call values
        this.wistiaJSONP9 = null;
        this.wistiaEmbed9 = null;
      } else {
        this.wistiaJSONP9 =
          "https://fast.wistia.com/embed/medias/" +
          this.post.wistia9 +
          ".jsonp";
        this.wistiaScript9 = document.createElement("script");
        this.wistiaScript9.setAttribute("src", this.wistiaJSONP9);
        document.head.appendChild(this.wistiaScript9);
        this.wistiaEmbed9 =
          "https://fast.wistia.com/embed/medias/" +
          this.post.wistia9 +
          "/swatch";
      }
    },
    "post.wistia10": function() {
      if (this.wistiaScript10)
        this.wistiaScript10.parentNode.removeChild(this.wistiaScript10);
      if (!this.post.wistia10) {
        //Empty call values
        this.wistiaJSONP10 = null;
        this.wistiaEmbed10 = null;
      } else {
        this.wistiaJSONP10 =
          "https://fast.wistia.com/embed/medias/" +
          this.post.wistia10 +
          ".jsonp";
        this.wistiaScript10 = document.createElement("script");
        this.wistiaScript10.setAttribute("src", this.wistiaJSONP10);
        document.head.appendChild(this.wistiaScript10);
        this.wistiaEmbed10 =
          "https://fast.wistia.com/embed/medias/" +
          this.post.wistia10 +
          "/swatch";
      }
    }
  },
  methods: {
    previewPost: function() {
      window.open(
        "https://transformation.wodapalooza.com/app/#dashboard/content/article/" +
          this.post.id,
        "_blank"
      );
    },
    goToPosts: function() {
      this.$router.push("/admin-panel/content");
    },
    onSave: function() {
      var _this = this;
      _this.savingData = true;
      var Post = Parse.Object.extend("Post");
      var post = new Post();
      post
        .save(this.post)
        .then(function(savedObject) {
          _this.post.id = savedObject.id;
          _this.savingData = false;
          _this.$message({
            type: "success",
            message: "Your post has been saved!"
          });
        })
        .catch(function(err) {
          _this.savingData = false;
          alert(err.message);
        });
    },
    removeMainImage(){
      this.post.image = null;
    },
    mainImageUpload: function() {
      var _this = this;
      window.fsClient
        .pick({
          fromSources: [
            "local_file_system",
            "imagesearch",
            "facebook",
            "instagram",
            "dropbox"
          ],
          maxSize: 2 * 1024 * 1024,
          maxFiles: 1,
          transformations: {
            crop: {
              aspectRatio: 16 / 9,
              force: true
            },
            circle: false
          }
        })
        .then(function(response) {
          console.log(response);
          if (response.filesUploaded.length) {
            _this.post.image = response.filesUploaded[0].url;
          }
          // declare this function to handle response
        });
    },
    onEditorBlur: function() {},
    onEditorReady: function() {},
    onEditorFocus: function() {},
    showImageUI: function() {
      var _this = this;
      window.fsClient
        .pick({
          fromSources: [
            "local_file_system",
            "imagesearch",
            "facebook",
            "instagram",
            "dropbox"
          ],
          maxSize: 3 * 1024 * 1024,
          maxFiles: 1
        })
        .then(function(response) {
          console.log(response);
          if (response.filesUploaded.length) {
            _this.post.image = response.filesUploaded[0].url;
          }
          // declare this function to handle response
        });
    }
  },
  computed: {
    editor() {
      return this.$refs.quillEditor.quill;
    }
  },
  mounted() {
    var _this = this;
    this.$nextTick(function() {
      if (_this.$route.params.id) {
        var Post = Parse.Object.extend("Post");
        var post = new Post();
        post.id = _this.$route.params.id;
        post
          .fetch()
          .then(savedPost => {
            const {attributes} = savedPost;
            _this.post = {
              ...this.post,
              id: savedPost.id,
              ...attributes
            };
          })
          .catch(function(err) {
            console.error(err);
            alert(err);
          });
      }
      var toolbar = _this.editor.getModule("toolbar");

      //this.getPost();
    });
  }
};
</script>

<style>
.el-form--label-top .form-save .el-form-item__label {
  text-align: center;
}
.form-save .el-button.el-button--primary {
  width: 100%;
  margin-bottom: 10px;
}
.form-save .el-button.el-button--default {
  width: 100%;
  margin: 0;
}
.form-save .el-select {
  width: 100%;
}
.main-blog-image-editor {
  width: 100%;
  min-height: 260px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
}
.main-blog-image-editor img {
  width: 100%;
  display: block;
}
.main-blog-image-editor .el-button {
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -69px;
  margin-top: -20px;
}
.ql-editor {
  font-size: 16px;
  color: #666;
}
.el-form--label-top .el-form-item__label {
  text-align: left;
  width: 100%;
  font-size: 18px;
  line-height: 26px;
  padding-bottom: 0;
  color: #999;
}
.ql-toolbar.ql-snow {
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  font-family: "proxima-nova", "Helvetica", "Arial", sans-serif;
  padding: 8px;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
}
.ql-container.ql-snow {
  border: 1px solid #dcdfe6;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  min-height: 200px;
}
.form-save {
  position: fixed;
  top: 112px;
  right: 50px;
  width: 260px;
  background: #fff;
  padding: 10px;
  box-sizing: border-box;
}
.blog-form {
  padding-right: 300px;
}
</style>